import { createContext } from "react";

export const MqttContext = createContext(null);
